import {Button, Link, Portal} from '@primer/react'
import {Dialog} from '@primer/react/experimental'

import styles from './ReportSpaceDialog.module.css'

export type ReportSpaceDialogProps = {
  reportUrl?: string
  onClose: () => void
  returnFocusRef?: React.RefObject<HTMLElement | null>
}

export const ReportSpaceDialog = ({reportUrl, onClose, returnFocusRef}: ReportSpaceDialogProps) => {
  const reportToSupport = (
    <div className={styles.ReportSpaceContainer}>
      <span>Contact GitHub Support about this user&apos;s spammy or abusive behavior.</span>
      <div className={styles.ReportSpaceFooterSpacing}>
        <div className={styles.ReportSpaceHelpText}>
          <span>Learn more about </span>
          <Link href="https://docs.github.com/articles/reporting-abuse-or-spam">reporting abuse to GitHub support</Link>
        </div>
        {reportUrl && (
          <Button
            variant="danger"
            as="a"
            href={reportUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.ReportSpaceSubmitButton}
          >
            Report abuse to GitHub support
          </Button>
        )}
      </div>
    </div>
  )

  return (
    <Portal>
      <Dialog
        /* eslint-disable-next-line @github-ui/dotcom-primer/no-title-case -- baselined during linter rollout */
        title="Report Space to GitHub Support"
        width="xlarge"
        height="auto"
        onClose={() => {
          onClose()
          // Return focus to the button that opened the dialog
          setTimeout(() => returnFocusRef?.current?.focus(), 0)
        }}
        className={styles.ReportSpaceDialog}
      >
        {reportToSupport}
      </Dialog>
    </Portal>
  )
}
